import { render, staticRenderFns } from "./work-view-mode.vue?vue&type=template&id=2e754f9e"
import script from "./work-view-mode.vue?vue&type=script&lang=js"
export * from "./work-view-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports